import React, { useCallback, useState } from "react";
import { SearchBox, withSearch } from "@elastic/react-search-ui";
import SelectBox from "./SelectBox";
import SearchFormComponent from "./SearchFormComponent";
import queryString from "../../../../helpers/queryString";

const SelectCategoryComponent = ({
  setFilter,
  filters,
  removeFilter,
  fieldName = "field_faq_product_categories",
}) => {
  const initialFilter =
    filters.filter((f) => f.field === fieldName)?.[0]?.values?.[0] || "";
  const [filterV, setFilterV] = useState(initialFilter);
  const setCategoryFilter = useCallback(
    (filterV) => {
      if (filterV) {
        setFilter(fieldName, filterV, "any");
      } else {
        removeFilter(fieldName);
      }
    },
    [fieldName, setFilter, removeFilter],
  );

  React.useEffect(() => {
    const search = queryString.parse(window.location.search);
    if (
      search &&
      (Array.isArray(search)
        ? search.length > 0
        : Object.keys(search).length > 0)
    ) {
      const { filters, q } = search;
      if (filters && filters.length > 0) {
        filters.forEach(({ field, values, type }) => {
          if (field === fieldName) {
            setFilterV(values[0]);
          }
        });
      }
    }
  }, []);

  return (
    <>
      <SelectBox {...{ value: filterV, setValue: setFilterV, fieldName }} />
      <SearchBox
        autocompleteSuggestions={true}
        view={(props) => (
          <SearchFormComponent {...props} {...{ setCategoryFilter, filterV }} />
        )}
      />
    </>
  );
};

const SelectCategory = withSearch(({ setFilter, filters, removeFilter }) => ({
  setFilter,
  filters,
  removeFilter,
}))(SelectCategoryComponent);

const OmronSearchBox = () => {
  return (
    <div className="u-box">
      <SelectCategory />
    </div>
  );
};

export default OmronSearchBox;
